import { ValueLabelResponse } from './ValueLabelResponse';

export enum Permission {
  Admin = 'Admin',
  TQAdmin = 'TQ Admin',
  Consultee = 'Consultee',
}

export type ExtendedPermissionType = ValueLabelResponse & { permissions?: string[] };
